import getHelper from '../../../services/getHelper';

export default getHelper('/certification-business-partners/:id');
